import type { IconSvgObject } from './types';

const LogoutCircle02Icon: IconSvgObject = [
  ["path", { d: "M11.9474 21C7.00589 21 3 16.9706 3 12C3 7.02944 7.00589 3 11.9474 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 8C17 8 21 10.946 21 12C21 13.0541 17 16 17 16M20.5 12H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LogoutCircle02Icon;
